"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FlexLayouter_1 = require("./layout/FlexLayouter");
class FlexContainer {
    constructor(node) {
        this.node = node;
        this.horizontal = true;
        this.reverse = false;
        this.layout = new FlexLayouter_1.FlexLayouter(this);
        this._wrap = false;
        this._alignItems = "stretch";
        this._justifyContent = "flex-start";
        this._alignContent = "flex-start";
        this._paddingLeft = 0;
        this._paddingTop = 0;
        this._paddingRight = 0;
        this._paddingBottom = 0;
        this._enabled = false;
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(v) {
        if (v !== this._enabled) {
            this._enabled = v;
            this.node.setFlexEnabled(v);
        }
    }
    get direction() {
        if (this.horizontal) {
            return this.reverse ? "row-reverse" : "row";
        }
        else {
            return this.reverse ? "column-reverse" : "column";
        }
    }
    set direction(f) {
        if (this.direction === f)
            return;
        this.horizontal = f === "row" || f === "row-reverse";
        this.reverse = f === "row-reverse" || f === "column-reverse";
        this.changedContents();
    }
    set wrap(v) {
        this._wrap = v;
        this.changedContents();
    }
    get wrap() {
        return this._wrap;
    }
    get alignItems() {
        return this._alignItems;
    }
    set alignItems(v) {
        if (this._alignItems === v)
            return;
        this._alignItems = v;
        this.changedContents();
    }
    get alignContent() {
        return this._alignContent;
    }
    set alignContent(v) {
        if (this._alignContent === v)
            return;
        this._alignContent = v;
        this.changedContents();
    }
    get justifyContent() {
        return this._justifyContent;
    }
    set justifyContent(v) {
        if (this._justifyContent === v)
            return;
        this._justifyContent = v;
        this.changedContents();
    }
    set padding(v) {
        this.paddingLeft = v;
        this.paddingTop = v;
        this.paddingRight = v;
        this.paddingBottom = v;
    }
    get padding() {
        return this.paddingLeft;
    }
    set paddingLeft(v) {
        this._paddingLeft = v;
        this.changedDimensions();
    }
    get paddingLeft() {
        return this._paddingLeft;
    }
    set paddingTop(v) {
        this._paddingTop = v;
        this.changedDimensions();
    }
    get paddingTop() {
        return this._paddingTop;
    }
    set paddingRight(v) {
        this._paddingRight = v;
        this.changedDimensions();
    }
    get paddingRight() {
        return this._paddingRight;
    }
    set paddingBottom(v) {
        this._paddingBottom = v;
        this.changedDimensions();
    }
    get paddingBottom() {
        return this._paddingBottom;
    }
    changedDimensions() {
        this.node.forceLayout();
    }
    changedContents() {
        this.node.changedContents();
    }
}
exports.FlexContainer = FlexContainer;
//# sourceMappingURL=FlexContainer.js.map